module.exports = __webpack_public_path__ + "static/media/Odysseus.4eda25db.jpg";